"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FutureOrdersCloseAllPositions = void 0;
const rxjs_1 = require("rxjs");
const interface_1 = require("../../../interface");
const trade_utils_lib_1 = require("trade_utils_lib");
const FutureAPI_1 = require("./../../../apis/FutureAPI");
/**当前仓位一键平仓 */
const FutureOrdersCloseAllPositions = (positions, timeoutDuring) => {
    return new rxjs_1.Observable((sub) => {
        const successPositions = [];
        const errorPositions = [];
        const timeoutMs = timeoutDuring !== null && timeoutDuring !== void 0 ? timeoutDuring : 60000;
        setTimeout(() => {
            sub.next({ successPositions: successPositions, errorPositions: errorPositions });
            sub.complete();
        }, timeoutMs);
        const checkResults = () => {
            const alreadyCount = successPositions.length + errorPositions.length;
            if (alreadyCount >= positions.length) {
                sub.next({ successPositions: successPositions, errorPositions: errorPositions });
                sub.complete();
            }
        };
        const positionSubs = [];
        positions.forEach((position) => {
            // 平空是买, 平多是卖
            const orderSide = Number(position.positionQuantity) >= 0 ? interface_1.CustomOrderSide.SELL : interface_1.CustomOrderSide.BUY;
            const positionSide = orderSide === interface_1.CustomOrderSide.SELL ? interface_1.FuturePositionSide.LONG : interface_1.FuturePositionSide.SHORT;
            const amount = new trade_utils_lib_1.SafeDecimal(position.positionQuantity).abs().toString();
            const orderRequest = {
                symbol: position.symbol,
                type: interface_1.CustomOrderType.MARKET_QTY,
                side: orderSide,
                price: undefined,
                qty: amount,
                position_side: positionSide,
            };
            const positionSub = (0, FutureAPI_1.postTwapOrderApi)(orderRequest).subscribe({
                next: () => {
                    successPositions.push(position);
                    checkResults();
                },
                error: () => {
                    errorPositions.push(position);
                    checkResults();
                },
            });
            positionSubs.push(positionSub);
        });
        return () => {
            positionSubs.forEach((sub) => {
                sub === null || sub === void 0 ? void 0 : sub.unsubscribe();
            });
        };
    });
};
exports.FutureOrdersCloseAllPositions = FutureOrdersCloseAllPositions;
